import { Box, Button } from '@amzn/awsui-components-core';
import { Epic, Task } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import constants from '../../../../common/constants';
import '../../../../resources/styles/scss/components/common/EpicEditor.css';
import TaskCreatorForm from './TaskCreatorForm';
import TasksList from './TasksList';

interface Props {
  tasks: Task[];
  onChange: (epicTitle: string, tasks: Task[]) => void;
  isEditable: boolean;
  epics: Epic[];
  epicTitle: string;
}

interface State {
  numberOfTaskForms: number;
}

export default class TaskEditor extends React.Component<Props, State> {
  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.state = {
      numberOfTaskForms: 0,
    };
  }

  public render() {
    const { tasks, isEditable, epics } = this.props;
    const { numberOfTaskForms } = this.state;

    const taskCreatorForms = [];
    if (isEditable) {
      for (let i = 0; i < numberOfTaskForms; i++) {
        taskCreatorForms.push(
          <div key={i} className="task-creator-form">
            <TaskCreatorForm epics={epics} tasks={tasks} confirmAddTask={this.onTaskConfirmed} />
          </div>,
        );
      }
    }

    const addTaskButton = isEditable ? (
      <Box margin={{ top: 'l', bottom: 'l', left: 'xl' }}>
        <Button iconName="add-plus" onClick={this.handleAddTask}>
          {constants.ADD_TASK_BUTTON_TEXT}
        </Button>
      </Box>
    ) : null;

    const taskListClassName = isEditable ? 'task-list task-list-editing' : 'task-list';

    return (
      <div className="task-editor-container">
        <div className={taskListClassName}>
          <TasksList
            epics={epics}
            isEditable={isEditable}
            onTasksChanged={this.onTasksChanged}
            tasks={tasks}
          />
        </div>
        {taskCreatorForms}
        {addTaskButton}
      </div>
    );
  }

  private handleAddTask = () => {
    const { numberOfTaskForms } = this.state;
    this.setState({
      numberOfTaskForms: numberOfTaskForms + 1,
    });
  };

  private onTaskConfirmed = (task: Task) => {
    this.onTasksChanged([...this.props.tasks, task]);
  };

  private onTasksChanged = (tasks: Task[]) => {
    const { onChange, epicTitle } = this.props;
    if (onChange) {
      onChange(epicTitle, tasks);
    }
  };
}
